import * as Sentry from "@sentry/react";
import { excludeGraphQLFetch } from "apollo-link-sentry";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
const RELEASE = import.meta.env.VITE_RELEASE;

const FILTERED = "[Filtered]";
const SENSITIVE_VARIABLES = ["token", "code"];

export const redactUrl = (url: string): string => url.replace(/\/external\/[^/?#]+/, `/external/${FILTERED}`);

export const redactVariables = (variables: Record<string, unknown>): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(variables).map(([key, value]) => [key, SENSITIVE_VARIABLES.includes(key) ? FILTERED : value]),
  );

export const redactBreadcrumb = (breadcrumb: Sentry.Breadcrumb): Sentry.Breadcrumb | null => {
  const filtered = excludeGraphQLFetch(breadcrumb);
  if (!filtered?.data) {
    return filtered;
  }

  const data = { ...filtered.data };
  ["from", "to", "url"].forEach(key => {
    if (typeof data[key] === "string") {
      data[key] = redactUrl(data[key]);
    }
  });

  return { ...filtered, data };
};

const configureSentry = (): void => {
  if (!import.meta.env.PROD) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    release: RELEASE,
    beforeBreadcrumb: redactBreadcrumb,
    beforeSend: event => {
      if (event.request?.url) {
        event.request.url = redactUrl(event.request.url);
      }
      if (typeof event.request?.headers?.Referer === "string") {
        event.request.headers.Referer = redactUrl(event.request.headers.Referer);
      }
      return event;
    },
  });
};

export default configureSentry;
